// 整体接口文件

import http from './request'

//请求首页用户信息数据接口
export const getUserInfo = ()=>{
    //返回一个promise对象
    return http.get('/user/info/get')
}   

//基础信息，人员信息接口
export const getPeopleList = (params)=>{
    // console.log(params,'params');
    return http.get('/person/personlist/get', params)
}

//基础信息，区域设置接口
export const getRegionList = (params)=>{
    return http.get('/community/communitylist/get', params)
}
